import { render, staticRenderFns } from "./SharingCreate.vue?vue&type=template&id=56b33970&scoped=true"
import script from "./SharingCreate.vue?vue&type=script&lang=js"
export * from "./SharingCreate.vue?vue&type=script&lang=js"
import style0 from "./SharingCreate.vue?vue&type=style&index=0&id=56b33970&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b33970",
  null
  
)

export default component.exports